"use client"
import { ReactNode, useCallback, useEffect, useMemo, useState } from "react"
/*import { FirebaseApp, getApps, initializeApp } from "firebase/app"
import { getMessaging, getToken, isSupported, onMessage } from "@firebase/messaging"
import { getAnalytics } from "firebase/analytics"
import { useUser } from "@lib/api/user"*/
import { SwContext } from "@components/ServiceWorker/Context"

//const PUBLIC_VAPID_KEY = "BATFetxb9X7CpSdpBeVXFlt4Gpv67kBmeolR2jNLIx3VWLfh8zN3F-k7y_2Ebnfk3KYmFRAtWXM4AgitPfZIiG4"

export function ServiceWorker({ children }: { children: ReactNode }) {
    const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null)

    useEffect(() => {
        if ("serviceWorker" in navigator) {
            async function registerServiceWorker() {
                const registration = await navigator.serviceWorker.register("/sw.js", {
                    scope: "/",
                    updateViaCache: "none"
                })
                setRegistration(registration)
            }
            void registerServiceWorker()
        }
    }, [])

    /*const [app, setApp] = useState<FirebaseApp | null>(null)
    useEffect(() => {
        async function init() {
            if (!(await isSupported())) {
                console.log("Firebase Messaging is not supported in this environment.")
                return
            }
            const firebaseConfig = {
                apiKey: "AIzaSyAg92qguj2tt9-aDZX4GMHsut-6TbFbFx8",
                projectId: "dvcforless-23906",
                messagingSenderId: "459878902602",
                appId: "1:459878902602:web:5910c399f3536af5c62fb3",
                measurementId: "G-EQ1YHLX4K6"
            }

            const apps = getApps()
            // Initialize Firebase
            const app = apps.find((app) => app.options.appId === firebaseConfig.appId) || initializeApp(firebaseConfig)
            getAnalytics(app)
            setApp(app)
        }
        void init()
    }, [])*/

    const getPermission = useCallback(
        async () => {
            /*if (!registration || !app) {
            console.log("No registration token available. Request permission to generate one.")
            return ""
        }
        const messaging = getMessaging(app)

        try {
            if (Notification.permission !== "granted") {
                const result = await Notification.requestPermission()
                if (result !== "granted") {
                    console.log("Permission not granted")
                    return ""
                }
            }
            const currentToken = await getToken(messaging, { vapidKey: PUBLIC_VAPID_KEY, serviceWorkerRegistration: registration })
            if (currentToken) {
                return currentToken
            }
        } catch (error) {
            console.log("An error occurred while retrieving token. ", error)
        }*/
            return ""
        },
        [
            /*registration, app*/
        ]
    )
    /* const { isAuthenticated } = useUser()
  *  useEffect(() => {
         if (registration && app) {
             const messaging = getMessaging(app)
             const unsubscribe = onMessage(messaging, (payload) => {
                 const notificationTitle = payload?.notification?.title || ""
                 const notificationBody = payload?.notification?.body || ""
                 const icon = payload?.notification?.icon || "/icons/android-chrome-192x192.png"
                 const image = payload?.notification?.image
                 const tag = payload?.messageId
                 // You can show a browser notification explicitly if needed, even without a UI
                 const notification = new Notification(notificationTitle, {
                     body: notificationBody,
                     icon, // Optional: path to an icon for the notification
                     tag,
                     lang: "en",
                     // @ts-ignore
                     vibrate: [200, 100, 200],
                     image // not well-supported
                 })
                 notification.onclick = () => {
                     // Close the notification
                     notification.close()
                     window.focus()
                 }
             })
             if (Notification.permission === "granted") {
                 void getPermission()
             }
             return () => {
                 unsubscribe()
             }
         }
     }, [registration, app, getPermission, isAuthenticated])*/

    const contextValue = useMemo(() => {
        return { registration, getPermission }
    }, [registration, getPermission])
    return <SwContext value={contextValue}>{children}</SwContext>
}
